import pagesJsonComponents from './pagesJsonComponents';

const {
	Footer,
	Header,
	HomePage,
	ProductPage,
	Breadcrumb,
	SearchPage,
	ShelfPage,
	SearchNotFound,
	ModalPage,
	MinicartPage,
	StoreMenu,
	CallCenter,
	Institutional,
	ProductNotFound,
} = pagesJsonComponents();

export default function defaultPages(templateId) {
	return [
		{
			pageName: 'Home',
			pageType: 'home',
			pageId: 'default-1',
			pageData: HomePage(templateId),
		},
		{
			pageName: 'Header',
			pageType: 'header',
			pageId: 'header',
			pageData: Header(templateId),
		},
		{
			pageName: 'StoreMenu',
			pageType: 'store-menu',
			pageId: 'menu-1',
			pageData: StoreMenu(templateId),
		},
		{
			pageName: 'Footer',
			pageType: 'footer',
			pageId: 'footer',
			pageData: Footer(templateId),
		},
		{
			pageName: 'Breadcrumb',
			pageType: 'breadcrumb',
			pageId: 'breadcrumb-1',
			pageData: Breadcrumb(templateId),
		},
		{
			pageName: 'Página de Produtos',
			pageType: 'product',
			pageId: 'product-1',
			pageData: ProductPage(templateId),
		},
		{
			pageName: 'Busca/Dep/Cat',
			pageType: 'search',
			pageId: 'search-1',
			pageData: SearchPage(templateId),
		},
		{
			pageName: 'Vitrine',
			pageType: 'shelf',
			pageId: 'shelf-1',
			pageData: ShelfPage(templateId),
		},
		{
			pageName: 'Minicart',
			pageType: 'minicart',
			pageId: 'minicart-1',
			pageData: MinicartPage(templateId),
		},
		{
			pageName: 'Modal Newsletter',
			pageType: 'modal-newsletter',
			pageId: 'modal-1',
			pageData: ModalPage(templateId),
		},
		{
			pageName: 'Busca Vazia',
			pageType: 'search-not-found',
			pageId: 'search-not-found-1',
			pageData: SearchNotFound(templateId),
		},
		{
			pageName: 'Produto Não Encontrado',
			pageType: 'not-found',
			pageId: 'not-found-1',
			pageData: ProductNotFound(templateId),
		},
		{
			pageName: 'Central de atendimento',
			pageType: 'custom',
			pageId: 'call-center-1',
			pageData: CallCenter(templateId),
		},
		{
			pageName: 'Institucional',
			pageType: 'custom',
			pageId: 'institucional-1',
			pageData: Institutional(templateId),
		},
	];
}
